<h2 mat-dialog-title>Filters</h2>
<mat-dialog-content class="mat-typography">
  <div class="main">
    <div class="block">
      <label>Waist:</label>
      <input class="signup-text" type="number" name="waist" [(ngModel)]="waist">
    </div>
    <div class="block">
      <label>Shoulders:</label>
      <input class="signup-text" type="number" name="shoulders" [(ngModel)]="shoulders">
    </div>
    <div class="block">
      <label>Neck:</label>
      <input class="signup-text" type="number" name="neck" [(ngModel)]="neck">
    </div>
    <div class="block">
      <label>Sleeves:</label>
      <input class="signup-text" type="number" name="sleeves" [(ngModel)]="sleeves">
    </div>
    <div class="block">
      <label>Status:</label>
      <select class="signup-select" name="selected" [(ngModel)]="status">
        <option disabled selected>Select Status</option>
        <option value='1'>Currently Available</option>
        <option value='2'>Currently on Rent</option>
      </select>
    </div>
    
    <div>
      Size: <span class="{{Sclicked}}" (click)="selectSize('Small')">S</span>
      <span class="{{Mclicked}}" (click)="selectSize('Medium')">M</span>
      <span class="{{Lclicked}}" (click)="selectSize('Large')">L</span>
      <span class="{{XLclicked}}" (click)="selectSize('extra-large')">XL</span>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button style="margin-right: 1em;" (click)="applyFilters()">Apply Filters</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>